export default "__VITE_ASSET__CQc8CPh2__"